import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { PlantLayoutEditorTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<PlantLayoutEditorTheme>;
const css = baseCss as ThemedCssFunction<PlantLayoutEditorTheme>;

export const PlantLayoutEditor = styled.div`
  width: 100%;
  height: 100%;
`;
